import { IStyleInfo } from '../../interface/custom-types'

export function getIconFromFormat<T>(format: string, formats: IStyleInfo<T>[]) {
  const icon = formats.find((item) => {
    if (typeof item.style === 'string') {
      return item.style === format
    } else {
      return undefined
    }
  })

  return icon?.icon
}
